if (!Date.now) {
	// IE8 doesn't have Date.now
	Date.now = function () {
		// The + converts the date object to a number (timestamp) which is what we would have gotten from .now
		return +new Date();
	};
}

var timeout = function (){

	var that = this.Prototype;
	var instance = {};

	var activityListeners = [];

	var defaults = {
		timeoutMilliseconds: 30 * 60 * 1000, // 30 minutes
		notificationMilliseconds: 20 * 60 * 1000, // 20 minutes
		monitorWaitMilliseconds: 5 * 1000, // 5 seconds
		presyncMilliseconds: 10 * 1000, // 10 seconds
		eventBroadcast: document,

		// Pass in baseurl versions instead of using these urls. These are mostly for reference.
		syncUrl: '/timeoutsync',

		activityEvents: [
			'keydown',
			'mousedown',
			'mousemove'
		]
	};

	var lastActivity = Date.now();
	var lastActivitySynced = null;
	var preSyncActive = false;
	var config = {};

	var idMonitor = null;

	var isNotificationActive = false;

	instance.events = {
		notificationShow: 'timeoutShowNotification',
		notificationClose: 'timeoutCloseNotification',
		logout: 'timeoutLogout',
		activity: 'timeoutActivity'
	};

	/**
	 * Merges config objects together
	 *
	 * obj defaultConfig
	 * obj userConfig
	 *
	 * return obj - merged configs
	 */
	function mergeConfigs(defaultConfig, userConfig) {
		var merged = [];
		if (userConfig == null) {
			merged = defaultConfig;
		} else {
			for (var key in defaultConfig)
				if (userConfig.hasOwnProperty(key)) {
					merged[key] = userConfig[key];
				} else {
					merged[key] = defaultConfig[key];
				}
		}
		return merged;
	}

	/**
	 * Does an ajax request using supplied params
	 *
	 * string method - GET, POST etc.
	 * string uri - Path to send the request to.
	 * mixed value - Value to be sent (will be converted to json)
	 * fn callback - Function to call with the request response
	 */
	function doAjaxRequest(method, uri, value, callback) {
		var xhr = new XMLHttpRequest();

		if (xhr.withCredentials === undefined) {
			console.error('Cors not supported by the current browser.');
		} else {
			xhr.onreadystatechange = function () {
				if (xhr.readyState == XMLHttpRequest.DONE) {
					if (xhr.status == 200) {

						var response = null;
						try {
							response = JSON.parse(xhr.responseText);
						} catch (e) {
							response = xhr.responseText;
						}
						callback(response);
					} else {

						console.error(xhr);
					}
				}
			};

			xhr.open(method, uri);
			xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded;charset=UTF-8");
			xhr.withCredentials = true;
			if (value != null && typeof value != 'string') {
				value = Object.keys(value)
					.map(function(key){
						return encodeURIComponent(key) + '=' + encodeURIComponent(value[key]);
					})
					.join('&');
			}
			xhr.send(value);
		}
	}

	/**
	 * Does a sync call
	 *
	 * Note: Additional calls will automatically be scheduled after this one completes.
	 */
	instance.syncActivity = function() {

		if (typeof lastActivity == 'undefined') {
			lastActivity = Date.now();
		}
		doAjaxRequest('POST', config.syncUrl, {lastActivity:lastActivity}, verifyLastActivity);
	};

	/**
	 * Schedules a call to run after wait time
	 *
	 * Note: Additional calls will automatically be scheduled after this one completes.
	 *
	 * int waitTime - in milliseconds. If blank next notification time will be used.
	 */
	instance.scheduleActivitySync = function(waitTime) {

		var notificationTime = getNextNotificationTime();

		if (waitTime == null) {
			waitTime = notificationTime;
		} else if (waitTime < 0) {
			console.warn("Timeout Sync: Sync wait time was < 0. Using 0.");
			waitTime = 0;
		} else if (!isNotificationActive && waitTime > notificationTime) {
			/**
			 * Notifications are shown as a result of syncing so syncing after the notification should have shown up
			 * will result in the notification being late though the timeout time will not change.
			 */
			console.warn('Timout Sync: Sync wait is longer than notification wait.');
		}

		if (idMonitor != null) {
			// We can register the monitor multiple times but it would be a waste so only keeping the one we need.
			window.clearTimeout(idMonitor);
			idMonitor = null;
		}

		idMonitor = window.setTimeout(instance.syncActivity, waitTime);
	};

	/**
	 * Gets the amount of time until the notification needs to be shown
	 *
	 * @returns int
	 */
	function getNextNotificationTime() {

		 var notificationTime = (lastActivity + config.notificationMilliseconds) - Date.now();

		if (notificationTime < 1000) {
			notificationTime = 0;
		}
		return notificationTime;
	}

	/**
	 * Triggers an event on the registered eventBroadcast element
	 */
	function triggerEvent(name, data) {
		var event = document.createEvent('CustomEvent');

		if (typeof data == 'undefined') {
			data = {};
		}
		event.initCustomEvent(name, true, true, data);
		config.eventBroadcast.dispatchEvent(event);
	}

	/**
	 * Triggers an event when the notification needs to be closed
	 */
	function triggerCloseNotificationEvent() {
		triggerEvent(instance.events.notificationClose);
	}

	/**
	 * Triggers an event when the notification needs to be shown
	 */
	function triggerNotificationEvent() {
		triggerEvent(instance.events.notificationShow);
	}

	/**
	 * Triggers an event when the user needs to be logged out
	 */
	function triggerLoggedOutEvent() {
		triggerEvent(instance.events.logout);
	}

	instance.triggerActivityEvent = function(lastActivity) {
		if (lastActivity == 'undefined') {
			lastActivity = Date.now();
		}
		triggerEvent(instance.events.activity, {lastActivity: lastActivity});
	};

	/**
	 * Verify the user's last activity
	 *
	 * int value - The last time the user was active
	 */
	function verifyLastActivity(value) {

		preSyncActive = false;

		if (value == "" || typeof value.lastActivity == "undefined") {
			triggerLoggedOutEvent();
		} else if (typeof value.lastActivity == 'string') {
			value.lastActivity = parseInt(value.lastActivity);
		}

		if (value.lastActivity < Date.now() - config.timeoutMilliseconds) {
			triggerLoggedOutEvent();
		}  else {

			if (lastActivitySynced == null || value.lastActivity > lastActivitySynced) {
				/**
				 * Make sure to set lastActivitySynced before calling triggerActivityEvent or we will catch it
				 * and end up trying to do a pointless pre-sync.
				 */
				lastActivitySynced = value.lastActivity;
				if (lastActivity != lastActivitySynced) {
					instance.triggerActivityEvent(value.lastActivity);
				}
			}

			var notificationTime = Date.now() - config.notificationMilliseconds;

			if (lastActivitySynced <= notificationTime) {

				// The last activity was long enough ago that we need to show the notification now
				if (isNotificationActive == false) {
					isNotificationActive = true;
					triggerNotificationEvent();
					/**
					 * Once the notification pops up it requires an active response such triggering the activity
					 * event (clicking continue) or opening another page (for sync to pick up).
					 * It will no longer let you stay active by doing things like moving the mouse or typing.
					 */
					removeActivityListeners();
				}

				// The notification syncs more often (using monitorWaitMilliseconds) to keep them synced across tabs
				instance.scheduleActivitySync(config.monitorWaitMilliseconds);
			} else {

				if (isNotificationActive) {
					isNotificationActive = false;
					registerActivityListeners();
					triggerCloseNotificationEvent();
				}

				instance.scheduleActivitySync();
			}
		}
	}

	/**
	 * Set the time the user was last active
	 */
	instance.setLastActivity = function(input) {

		if (input instanceof Event
			&& typeof input.detail !== 'undefined'
			&& typeof input.detail.lastActivity !== 'undefined') {

			lastActivity = input.detail.lastActivity;
		} else if (isNaN(input)) {
			lastActivity = Date.now();
		} else {
			lastActivity = input;
		}

		if (lastActivity > lastActivitySynced) {
			if (isNotificationActive) {
				// If the notification is active sync immediately
				instance.scheduleActivitySync(0);
			} else if (!preSyncActive) {
				preSyncActive = true;

				/**
				 * If there is new activity the script should sync before notification instead of on it, which is the
				 * default, so that other tabs that will sync on notification can get this new time.
				 */
				var nextNotificationTime = getNextNotificationTime();
				if ((nextNotificationTime - config.presyncMilliseconds) >= 0) {
					// Only do it in advance if there is actually enough time
					nextNotificationTime = nextNotificationTime - config.presyncMilliseconds;
				}
				instance.scheduleActivitySync(nextNotificationTime);
			}
		}
	};

	/**
	 * Register listeners for events (aside from .events.activity) that should be counted as activity
	 */
	function registerActivityListeners() {

		config.activityEvents.forEach(function(event) {
			document.addEventListener(event, instance.setLastActivity, false);
		});
	}

	/**
	 * Remove listeners for events (aside from .events.activity) that should be counted as activity
	 */
	function removeActivityListeners() {
		config.activityEvents.forEach(function(event) {
			document.removeEventListener(event, instance.setLastActivity, false);
		});
	}

	var constructor = function(userConfig) {

		config = mergeConfigs(defaults, userConfig);

		// Users can either set activity using the event or via the setLastActivity method
		config.eventBroadcast.addEventListener(instance.events.activity, instance.setLastActivity, false);
		registerActivityListeners();

		return instance;
	};

	return constructor;
}();
